<template>
  <div class="form-control vehicle-research__field">
    <label :for="id" class="sr-only">
      {{ label }}
    </label>

    <div class="vehicle-research__select-wrapper">
      <select
        :id="id"
        class="select vehicle-research__select"
        :value="modelValue"
        :disabled="disabled"
        required
        @change="onSelectChange"
      >
        <option value="" disabled>{{ placeholder }}</option>
        <option v-for="option in options" :key="option.id" :value="option.id">
          {{ option.label }}
        </option>
      </select>

      <svg
        aria-hidden="true"
        focusable="false"
        fill="none"
        width="10"
        viewBox="0 0 10 6"
        class="vehicle-research__select-chevron"
      >
        <path d="m1 1 4 4 4-4" stroke="currentColor" stroke-linecap="square" />
      </svg>
    </div>
  </div>
</template>

<script>
export default {
  name: 'VehicleSelect',
  props: {
    id: { type: String, required: true },
    label: { type: String, required: true },
    modelValue: { type: [String, Number], default: '' },
    options: { type: Array, default: () => [] },
    disabled: { type: Boolean, default: false },
    placeholder: { type: String, required: true },
  },
  emits: ['update:modelValue'],
  methods: {
    onSelectChange(event) {
      const raw = event.target.value;
      this.$emit('update:modelValue', raw === '' ? '' : String(raw));
    },
  },
};
</script>
